<template>
  <div class="inner-content">
    <section>
      <div class="container-fluid">
        <div class="row m-0">
          <div class="col-12">
            <div class="card">
              <div class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative py-4">
                <div class="content-card-left">
                  <h4 class="card-title text-white">{{ $route.query.companyName }} — CLAIMS / COMMISSION</h4>
                </div>
                <div class="content-card-right ms-auto d-flex flex-wrap">
                  <a href="#addClaim" data-bs-toggle="modal" data-bs-target="#addClaim" @click.prevent
                    class="btn btn-add d-flex flex-wrap align-items-center justify-content-center rounded-circle me-2">
                    <i class="bi bi-plus-square-fill text-white"></i>
                  </a>
                  <a href="#" @click.prevent="pdfTrigger++"
                    class="btn btn-add d-flex flex-wrap align-items-center justify-content-center rounded-circle">
                    <img src="@/assets/images/pdf.png" alt="pdf" class="small-image white-image" />
                  </a>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="header-content">
                  <!-- Filters: category + date range -->
                  <form class="table-header mx-0 mb-4 custom-form">
                    <div class="row m-0 align-items-center">
                      <div class="col-lg-2 col-md-2 col-sm-3 col-12 px-0">
                        <h4 class="filter mb-lg-0 mb-md-0 mb-sm-0 mb-3">
                          <i class="bi bi-funnel me-1 position-relative"></i>Filters
                        </h4>
                      </div>
                      <div class="col-lg-3 col-md-4 col-sm-5 col-12 px-0 pe-lg-3 mb-lg-0 mb-3">
                        <div class="position-relative form-group mb-0">
                          <select v-model="category" class="form-select custom-select w-100">
                            <option value="all">All Categories</option>
                            <option value="claim">Claim</option>
                            <option value="commission">Commission</option>
                            <option value="salary">Salary</option>
                          </select>
                          <label class="position-absolute select-label active">Category</label>
                          <i class="bi bi-caret-down-fill select-arrow position-absolute"></i>
                        </div>
                      </div>
                      <div class="col-lg-7 col-md-6 col-sm-4 col-12 px-0 ms-auto">
                        <v-date-picker class="custom-calendar left-caret-none" popover-align="right" :step="1"
                          v-model="range" is-range :columns="$screens({ default: 2, lg: 2 })"
                          :masks="{ input: 'DD/MM/YY' }">
                          <template v-slot="{ inputValue, inputEvents }">
                            <div class="d-flex flex-wrap align-items-center justify-content-lg-end justify-content-md-end justify-content-sm-end justify-content-start">
                              <div class="position-relative calendar-input-wrapper clearfix">
                                <span class="d-inline-block me-4 float-left">From</span>
                                <i class="bi bi-calendar3 position-absolute icon-left-placement"></i>
                                <input :value="inputValue.start" v-on="inputEvents.start"
                                  class="border-0 icon-left position-relative float-left" />
                              </div>
                              <div class="position-relative calendar-input-wrapper clearfix ms-lg-3 ms-md-3 ms-sm-3 ms-0">
                                <span class="d-inline-block me-4 float-left">To</span>
                                <i class="bi bi-calendar3 position-absolute icon-left-placement"></i>
                                <input :value="inputValue.end" v-on="inputEvents.end"
                                  class="border-0 icon-left position-relative float-left" />
                              </div>
                            </div>
                          </template>
                        </v-date-picker>
                      </div>
                    </div>
                  </form>

                  <div class="table-responsive mb-0">
                    <table id="my-table" class="custom-table shop-table">
                      <thead>
                        <tr>
                          <th class="text-capitalize">Id</th>
                          <th class="text-capitalize">Date</th>
                          <th class="text-capitalize">Category</th>
                          <th class="text-capitalize">Description</th>
                          <th class="text-capitalize text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="claim in claims" :key="claim.id">
                          <td>{{ claim.id }}</td>
                          <td>{{ formatDate(claim.payment_at) }}</td>
                          <td class="text-capitalize">{{ claim.category }}</td>
                          <td>{{ claim.description || '---' }}</td>
                          <td class="text-end">{{ claim.amount }}</td>
                        </tr>
                        <tr v-if="claims.length === 0">
                          <td colspan="5" class="text-center">No entries found.</td>
                        </tr>
                        <tr v-if="claims.length" class="fw-bold">
                          <td colspan="4">Total</td>
                          <td class="text-end">{{ pageTotal.toFixed(2) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card-footer custom-pagination d-flex flex-wrap justify-content-between m-0 px-4 pb-0 border-0 bg-transparent">
                <p class="d-lg-inline-block table-data">
                  Showing
                  {{ total_count ? (current_page * entries_per_page - (entries_per_page - 1)) : 0 }}
                  to
                  {{ current_page * entries_per_page - (entries_per_page - claims.length) }}
                  of {{ total_count }} entries.
                </p>
                <div class="d-inline-block ms-auto me-lg-0 me-md-0 me-sm-0 me-auto mb-lg-0 mb-md-0 mb-sm-0 mb-4 pagination-wrapper">
                  <v-pagination class="d-flex flex-lg-wrap flex-md-wrap flex-sm-wrap align-items-center p-0 m-0"
                    v-model="current_page" :pages="total_pages" :range-size="3" @update:modelValue="loadClaims" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <company-claim-add-modal :company_id="company_id" @load-claims="loadClaims"></company-claim-add-modal>
  <company-claims-pdf
    :company_id="company_id"
    :company_name="$route.query.companyName"
    :trigger="pdfTrigger"
    :filters="{ category, startDate, endDate }"
    @alert-event="showGrowl"
  ></company-claims-pdf>
  <Alert v-if="growlMessage" :name="alert_m.name" :alertHeading="alert_m.heading" :alertDescription="alert_m.description"></Alert>
</template>

<script>
import { onMounted, ref, reactive, watch, computed } from 'vue';
import CompanyClaimAddModal from '@/components/modals/CompanyClaimAddModal.vue';
import CompanyClaimsPdf from '@/components/pdf/CompanyClaimsPdf.vue';
import companybalance from '@/services/CompanyBalanceService';
import VPagination from '@hennge/vue3-pagination';
import Alert from '@/components/alert';
import moment from 'moment';

export default {
  props: {
    company_id: Number,
  },
  components: {
    CompanyClaimAddModal,
    CompanyClaimsPdf,
    VPagination,
    Alert,
  },
  setup(props) {
    const claims = ref([]);
    const current_page = ref(1);
    const entries_per_page = ref(50);
    const total_count = ref(0);
    const total_pages = ref(0);
    const category = ref('all');
    // Prefill the date filter to the current month (like the transactions page).
    const range = ref({
      start: moment().startOf('month').toDate(),
      end: moment().toDate(),
    });
    const startDate = ref(moment(range.value.start).format('YYYY-MM-DD'));
    const endDate = ref(moment(range.value.end).format('YYYY-MM-DD'));
    const pdfTrigger = ref(0);
    const growlMessage = ref(false);
    const alert_m = reactive({ name: '', heading: '', description: '' });

    const formatDate = (value) => (value ? moment(value).format('DD/MM/YY') : '');

    const pageTotal = computed(() =>
      claims.value.reduce((sum, c) => sum + (Number(c.amount) || 0), 0)
    );

    const loadClaims = async () => {
      await companybalance
        .getCategoryTransactions(props.company_id, current_page.value, {
          category: category.value,
          startDate: startDate.value,
          endDate: endDate.value,
        })
        .then((response) => {
          claims.value = response.data.data;
          total_pages.value = response.data.last_page;
          current_page.value = response.data.current_page;
          entries_per_page.value = response.data.per_page;
          total_count.value = response.data.total;
        });
    };

    const showGrowl = (alertType) => {
      if (alertType === 'add') {
        alert_m.name = 'success';
        alert_m.description = 'Record Added Successfully';
      } else {
        alert_m.name = 'danger';
        alert_m.description = 'No Record Found. Please try with valid data';
      }
      alert_m.heading = 'Claim / Commission';
      growlMessage.value = true;
      setTimeout(() => { growlMessage.value = false; }, 5000);
    };

    onMounted(() => {
      loadClaims();
    });

    watch(category, () => {
      current_page.value = 1;
      loadClaims();
    });

    watch(
      () => range.value,
      (currentValue) => {
        if (currentValue) {
          startDate.value = currentValue.start ? moment(currentValue.start).format('YYYY-MM-DD') : '';
          endDate.value = currentValue.end ? moment(currentValue.end).format('YYYY-MM-DD') : '';
          current_page.value = 1;
          loadClaims();
        }
      }
    );

    return {
      claims,
      current_page,
      total_pages,
      total_count,
      entries_per_page,
      category,
      startDate,
      endDate,
      range,
      pdfTrigger,
      pageTotal,
      loadClaims,
      formatDate,
      showGrowl,
      growlMessage,
      alert_m,
    };
  },
};
</script>
